import { render, staticRenderFns } from "./servicetypes.vue?vue&type=template&id=b05f9a62"
import script from "./servicetypes.vue?vue&type=script&lang=js"
export * from "./servicetypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports